import { useLocation } from 'react-router-dom';
import { useAuth } from './Auth';
import { useAdminLibrary } from '../Admin/AdminLibraryContext';

/**
 * The "active" library id for the current user.
 *
 * - Super Admin (role 1): the library currently chosen in the top-bar selector
 *   (from AdminLibraryContext).
 * - Everyone else: their own `user.library_id`, exactly as before.
 *
 * This is the single seam that lets the Super Admin reuse every librarian page
 * without those pages needing to know an admin exists. Safe to call anywhere the
 * app is wrapped in AuthProvider; the admin context is optional.
 */
export const useActiveLibraryId = () => {
  const { user } = useAuth();
  const admin = useAdminLibrary();

  if (admin?.isAdmin) return admin.selectedLibraryId;
  return user?.library_id;
};

/**
 * The route prefix for the section the user is currently in: `/admin` when the
 * URL is under the admin portal, otherwise `/librarian`.
 *
 * Reused librarian pages call this so their internal navigation stays inside the
 * section the user came from. Off `/admin` it returns `/librarian`, so existing
 * librarian behaviour is unchanged.
 */
export const useSectionBase = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin')) return '/admin';
  if (pathname.startsWith('/school')) return '/school';
  return '/librarian';
};

export default useActiveLibraryId;
